export { default } from './PlanetsSlider';
